<template>
  <div>
    <a-button icon="reload" @click="getMailing(mailing.id)">Refresh</a-button>
    <itemMail v-if="typeof mailing.id !== 'undefined'" :mailing="mailing" :opens="true" :keepOpen="true"  :mailings="mailings" :listas="listas" :insights="true"/>
  </div>
</template>

<script>

import itemMail from '../components/ItemMail.vue'
import utils from '../service/service.js'

export default {
  name: 'ampliado',
  props: ["idMail"],
  components: {
    itemMail,
  },
  mixins:[utils],
  data(){ 
    return {
      listas : [],
      mailings : [],
      mailing : {},
      visibleModalEmail: true
    }
  },
  methods: {
     getListas(){

      this.sendRequest({
        method: 'GET',
        url: 'listas',

      }).then(({data}) => {
        this.listas = data
      })
    },

    getMailings(){
       this.sendRequest({
         method: 'POST',
         url: 'mailings/list'
       }).then(({data}) => {
         this.mailings = data.mailings
       });
    },
    async getMailing(id){
       const {data} = await this.sendRequest({
         method: 'GET',
         url: 'mailings/' + id
       });
      this.mailing = data;
    },

    async setLiveRefresh() {
      const $this = this;
      setTimeout(async () => {
        if ($this.liveRefresh) {
          await $this.getMailing($this.idMail);
        }
        await $this.setLiveRefresh();
      }, 5000)
    }
  },
  mounted: function(){
    this.getMailing(this.idMail);
    this.getListas();
    this.getMailings();
    this.setLiveRefresh();
  }
}
</script>

<style scoped>
  .events {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .events .ant-badge-status {
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    text-overflow: ellipsis;
    font-size: 12px;
  }
  .ant-fullcalendar-header{
    display: none;
  }
  .filtros{
    margin: 10px 0px 20px !important;
  }
  .resumen .ant-card{
    border-radius: 5px;
    margin-bottom: 15px;
  }
  .titulo{
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: left;
  }
  .tab {
    margin-right: 20px;
    border-bottom: 2px solid;
  }
  .titulo .tabNoSelect{
    font-size: 16px;
    opacity: 0.6;
    border-bottom: none;
    cursor: pointer;
  }
  .titulo .tabNoSelect:hover{
    color: #1890ff;
  }
  .shadow {
    box-shadow: 2px 1px 5px -4px;
  }
  .shadowInputs {
    box-shadow: 1px 1px 5px -5px;
  }
  .calendar{
    background-color: white;
    padding: 10px 10px 10px;
    margin-bottom: 10px;
  }
</style>